/* =====================================================================
   Maison Stiletto V5 : en-tete (sections/mp-header.liquid)
   Charge en defer par sections/mp-global.liquid, apres mp-base.js (window.MP).
   1. Barre collante qui se cache au defilement vers le bas et revient vers le haut ;
      tient a jour --mp-header-h (hauteur de la barre) et --mp-header-offset (place
      reellement occupee en haut de l'ecran, 0 quand l'en-tete est cache) sur :root.
   2. Bandeau d'annonces : rotation douce, pause au survol, au focus et au bouton.
   3. Mega menu : ouverture apres 120 ms de survol, fermeture 200 ms apres la sortie,
      clavier (Entree / Espace sur le bouton, fleche bas, Echap), premier tap sur tactile.
   4. Tiroir mobile (MP.layer) en tiroirs successifs, glisser vers la gauche pour fermer.
   5. Recherche (MP.layer) : /search/suggest.json, mini-cartes au rendu de mp-card.
   Contrats : [data-mp-search-open] ouvre la recherche ; [data-mp-cart-open] et
   [data-mp-cart-count] sont geres par mp-cart.js (ici : seulement le libelle du lien).
   ===================================================================== */
(function () {
  'use strict';

  var MP = window.MP;
  if (!MP || !MP.layer) return;
  if (MP.header && MP.header.__v5) return; // double inclusion

  var doc = document;
  var html = doc.documentElement;

  var EXCLUDED_COLLECTIONS = ['frontpage', 'alo-kendall'];

  /* ---------- Outils ---------- */
  function $(sel, root) { return (root || doc).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function raf(fn) {
    if (doc.hidden || !window.requestAnimationFrame) return setTimeout(fn, 16);
    return window.requestAnimationFrame(fn);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  // titre produit sans les etiquettes collees entre guillemets ("best seller", "new"), comme dans mp-card
  function cleanTitle(t) {
    var raw = String(t == null ? '' : t);
    var c = raw.split('"')[0].trim();
    return c || raw.replace(/"/g, '').trim();
  }
  function focusEl(el) {
    if (!el || !el.focus) return;
    try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); }
  }
  function scrollTop() { return Math.max(0, window.pageYOffset || html.scrollTop || 0); }
  function isReduced() { return !!(MP.mq && MP.mq.reduce && MP.mq.reduce.matches); }
  function isDesktop() { return MP.mq && MP.mq.desktop ? MP.mq.desktop.matches : window.innerWidth >= 990; }
  function matches(el, sel) { try { return !!(el && el.matches && el.matches(sel)); } catch (e) { return false; } }
  function visible(el) { return !!(el && el.getClientRects().length) && window.getComputedStyle(el).visibility !== 'hidden'; }
  function isEsc(e) { return e.key === 'Escape' || e.key === 'Esc'; }
  function onMq(mql, fn) {
    if (!mql) return function () {};
    if (mql.addEventListener) { mql.addEventListener('change', fn); return function () { mql.removeEventListener('change', fn); }; }
    if (mql.addListener) { mql.addListener(fn); return function () { mql.removeListener(fn); }; }
    return function () {};
  }
  // chaines : mp.header.* (bloc data-mp-i18n="header" de mp-header.liquid) et mp.general.* ; repli anglais
  function T(key, fallback, vars) { return MP.t('header', key, fallback, vars); }
  function G(key, fallback) { return MP.t('general', key, fallback); }
  function cartLabel(n) {
    if (!n) return T('bag', 'Bag');
    if (n === 1) return T('bag_one', 'Bag, 1 item');
    return T('bag_many', 'Bag, [count] items', { count: n });
  }
  // titres de collection : casse de phrase (les titres de l'admin sont en capitales)
  function sentence(s) {
    s = String(s == null ? '' : s).trim().toLowerCase();
    return s.charAt(0).toUpperCase() + s.slice(1);
  }

  // ecouteurs a retirer quand la section est rechargee dans l'editeur
  function Bag() { this.list = []; this.undo = []; }
  Bag.prototype.on = function (target, type, fn, opts) {
    if (!target) return;
    target.addEventListener(type, fn, opts || false);
    this.list.push([target, type, fn, opts || false]);
  };
  Bag.prototype.off = function () {
    this.list.forEach(function (l) { l[0].removeEventListener(l[1], l[2], l[3]); });
    this.undo.forEach(function (fn) { try { fn(); } catch (e) {} });
    this.list = [];
    this.undo = [];
  };

  /* ---------- Instance ---------- */
  var current = null;

  function create(root) {
    var bag = new Bag();
    var timers = [];
    function later(fn, ms) { var t = setTimeout(fn, ms); timers.push(t); return t; }

    var host = root.closest('.shopify-section') || root;
    host.classList.add('mp-header-section');
    var group = host.parentElement;
    // repli si :has() n'est pas pris en charge (voir mp-header.css, section 0)
    if (group && group.id === 'header-group') group.classList.add('mp-header-group');

    var bar = $('[data-mp-header-bar]', root);
    var ann = $('[data-mp-announce]', root);
    var veil = $('[data-mp-veil]', root);
    var drawer = takePanel('mp-menu-drawer');
    var search = takePanel('mp-search');

    // les calques passent dans body : l'en-tete (z-index 700, transform au masquage) les garderait sous le voile
    function takePanel(id) {
      var el = root.querySelector('#' + id);
      $$('body > #' + id).forEach(function (old) {
        if (old === el) return;
        if (MP.layer.isOpen(old)) MP.layer.close({ silent: true });
        if (old.parentNode) old.parentNode.removeChild(old);
      });
      return el ? MP.portal(el) : null;
    }

    /* ===== 1. Barre collante, masquage au defilement, variables CSS ===== */
    var hideOnScroll = root.getAttribute('data-hide-on-scroll') !== 'false';
    var annH = 0;
    var barH = 0;
    var hidden = false;
    var anchor = scrollTop();
    var lastOffset = null;
    var pending = false;

    function setVar(name, px) { html.style.setProperty(name, px + 'px'); }
    function measure() {
      annH = ann ? Math.round(ann.getBoundingClientRect().height) : 0;
      barH = bar ? Math.round(bar.getBoundingClientRect().height) : 0;
      setVar('--mp-announce-h', annH);
      setVar('--mp-header-h', barH);
      writeOffset(true);
    }
    // decalage reel : bas de la barre dans l'ecran (bandeau encore visible en haut de page), 0 si cachee
    function writeOffset(force) {
      var v = hidden ? 0 : Math.max(0, annH - scrollTop()) + barH;
      if (!force && v === lastOffset) return;
      lastOffset = v;
      setVar('--mp-header-offset', v);
    }
    function keyboardFocusInside() {
      var a = doc.activeElement;
      return !!(a && a !== doc.body && root.contains(a) && matches(a, ':focus-visible'));
    }
    function canHide() {
      return hideOnScroll && !megaItem && !MP.layer.isOpen() && !keyboardFocusInside();
    }
    function setHidden(h) {
      if (h === hidden) return;
      hidden = h;
      host.classList.toggle('is-mp-hidden', h);
      root.classList.toggle('is-hidden', h);
      writeOffset();
      MP.emit(root, 'mp:header:visibility', { hidden: h, offset: lastOffset });
    }
    function tick() {
      pending = false;
      var y = scrollTop();
      if (y <= annH + barH || !canHide()) {
        setHidden(false);
        anchor = y;
      } else {
        // seuil de 12 px : un petit mouvement du pouce ne fait pas clignoter la barre
        var d = y - anchor;
        if (d > 12) { setHidden(true); anchor = y; }
        else if (d < -12) { setHidden(false); anchor = y; }
      }
      writeOffset();
    }
    bag.on(window, 'scroll', function () {
      if (pending) return;
      pending = true;
      raf(tick);
    }, { passive: true });
    bag.on(root, 'focusin', function () {
      if (hidden) { setHidden(false); anchor = scrollTop(); }
    });
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () { measure(); });
      if (bar) ro.observe(bar);
      if (ann) ro.observe(ann);
      bag.undo.push(function () { ro.disconnect(); });
    } else {
      bag.on(window, 'resize', MP.debounce(measure, 120));
    }
    bag.on(window, 'load', measure, { once: true });
    measure();

    /* ===== 2. Bandeau d'annonces ===== */
    var announce = (function () {
      if (!ann) return null;
      var msgs = $$('[data-mp-msg]', ann);
      if (msgs.length < 2) return null;
      var track = $('[data-mp-announce-track]', ann);
      var pauseBtn = $('[data-mp-announce-pause]', ann);
      var speed = Math.max(3, parseInt(ann.getAttribute('data-speed'), 10) || 5) * 1000;
      var i = 0;
      var t = null;
      var hover = false;
      var focus = false;
      var paused = false;
      var touched = false;

      function show(n) {
        i = (n + msgs.length) % msgs.length;
        msgs.forEach(function (m, k) {
          var on = k === i;
          m.classList.toggle('is-active', on);
          if (on) m.removeAttribute('aria-hidden');
          else m.setAttribute('aria-hidden', 'true');
        });
      }
      function running() { return !hover && !focus && !paused && !touched && !isReduced() && !doc.hidden; }
      function schedule() {
        clearTimeout(t);
        var run = running();
        // annonce lue seulement quand la personne change elle-meme de message
        if (track) track.setAttribute('aria-live', run ? 'off' : 'polite');
        if (run) t = setTimeout(function () { show(i + 1); schedule(); }, speed);
      }
      function setPaused(p) {
        paused = p;
        if (pauseBtn) {
          pauseBtn.setAttribute('aria-pressed', p ? 'true' : 'false');
          pauseBtn.setAttribute('aria-label', p ? T('announcement_resume', 'Resume announcements') : T('announcement_pause', 'Pause announcements'));
        }
        schedule();
      }
      bag.on($('[data-mp-announce-prev]', ann), 'click', function () { show(i - 1); schedule(); });
      bag.on($('[data-mp-announce-next]', ann), 'click', function () { show(i + 1); schedule(); });
      bag.on(pauseBtn, 'click', function () { setPaused(!paused); });
      bag.on(ann, 'mouseenter', function () { hover = true; schedule(); });
      bag.on(ann, 'mouseleave', function () { hover = false; schedule(); });
      bag.on(ann, 'focusin', function () { focus = true; schedule(); });
      bag.on(ann, 'focusout', function (e) {
        if (e.relatedTarget && ann.contains(e.relatedTarget)) return;
        focus = false;
        schedule();
      });
      // sur telephone, toucher le bandeau arrete la rotation pour la visite
      bag.on(ann, 'touchstart', function () { touched = true; schedule(); }, { passive: true });
      bag.on(doc, 'visibilitychange', schedule);
      bag.undo.push(onMq(MP.mq && MP.mq.reduce, schedule));
      bag.undo.push(function () { clearTimeout(t); });
      schedule();
      return {
        select: function (el) {
          var k = msgs.indexOf(el);
          if (k < 0) return;
          show(k);
          paused = true;
          schedule();
        },
        resume: function () { setPaused(false); }
      };
    })();

    /* ===== 3. Mega menu ===== */
    var megaItem = null;
    var openT = null;
    var closeT = null;
    var lastPointer = 'mouse';
    var items = $$('[data-mp-mega-item]', root);

    function panelOf(item) { return item ? $('[data-mp-mega]', item) : null; }
    function toggleOf(item) { return item ? $('[data-mp-mega-toggle]', item) : null; }
    function linkOf(item) { return item ? $('[data-mp-mega-link]', item) : null; }
    function setItem(item, on) {
      item.classList.toggle('is-open', on);
      var t = toggleOf(item);
      if (t) t.setAttribute('aria-expanded', on ? 'true' : 'false');
    }
    function focusFirst(item) {
      later(function () {
        var first = $$('a[href]', panelOf(item)).filter(visible)[0];
        focusEl(first);
      }, 30);
    }
    function megaOpen(item, opts) {
      clearTimeout(openT);
      clearTimeout(closeT);
      if (!panelOf(item) || !isDesktop()) return;
      if (megaItem === item) {
        if (opts && opts.focus) focusFirst(item);
        return;
      }
      var switching = !!megaItem;
      if (megaItem) setItem(megaItem, false);
      root.classList.toggle('is-mega-switch', switching);
      megaItem = item;
      setItem(item, true);
      root.classList.add('is-mega');
      setHidden(false);
      if (opts && opts.focus) focusFirst(item);
      MP.emit(root, 'mp:header:mega', { open: true, item: item });
    }
    function megaClose(opts) {
      clearTimeout(openT);
      clearTimeout(closeT);
      if (!megaItem) return;
      var item = megaItem;
      megaItem = null;
      root.classList.remove('is-mega-switch');
      setItem(item, false);
      root.classList.remove('is-mega');
      if (opts && opts.focus) focusEl(toggleOf(item) || linkOf(item));
      MP.emit(root, 'mp:header:mega', { open: false, item: item });
    }
    function scheduleClose(ms) {
      clearTimeout(closeT);
      closeT = setTimeout(function () { megaClose(); }, ms);
    }

    items.forEach(function (item) {
      var hasPanel = !!panelOf(item);
      bag.on(item, 'pointerenter', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        clearTimeout(closeT);
        clearTimeout(openT);
        if (!hasPanel) {
          if (megaItem) scheduleClose(120);
          return;
        }
        if (megaItem === item) return;
        openT = setTimeout(function () { megaOpen(item); }, 120);
      });
      bag.on(item, 'pointerleave', function (e) {
        if (e.pointerType && e.pointerType !== 'mouse') return;
        clearTimeout(openT);
        if (megaItem) scheduleClose(200);
      });
      if (!hasPanel) return;

      var link = linkOf(item);
      var tog = toggleOf(item);
      // tactile (tablette en paysage) : premier tap = ouvre le panneau, second tap = suit le lien
      bag.on(link, 'pointerdown', function (e) { lastPointer = e.pointerType || 'mouse'; });
      bag.on(link, 'click', function (e) {
        var touch = lastPointer === 'touch' || lastPointer === 'pen';
        lastPointer = 'mouse';
        if (touch && megaItem !== item) {
          e.preventDefault();
          megaOpen(item);
        }
      });
      bag.on(link, 'keydown', function (e) {
        var k = e.key;
        if (k === 'ArrowDown' || k === 'Down' || k === ' ' || k === 'Spacebar') {
          e.preventDefault();
          megaOpen(item, { focus: true });
        }
      });
      bag.on(tog, 'click', function (e) {
        e.preventDefault();
        if (megaItem === item) megaClose();
        else megaOpen(item);
      });
      bag.on(tog, 'keydown', function (e) {
        if (e.key === 'ArrowDown' || e.key === 'Down') {
          e.preventDefault();
          megaOpen(item, { focus: true });
        }
      });
      // fleches haut et bas entre les liens du panneau
      bag.on(panelOf(item), 'keydown', function (e) {
        var k = e.key;
        if (k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'Down' && k !== 'Up') return;
        var links = $$('a[href]', panelOf(item)).filter(visible);
        var at = links.indexOf(doc.activeElement);
        if (at < 0) return;
        e.preventDefault();
        if (k === 'ArrowDown' || k === 'Down') focusEl(links[Math.min(links.length - 1, at + 1)]);
        else if (at === 0) focusEl(tog || link);
        else focusEl(links[at - 1]);
      });
      // le focus clavier quitte la rubrique : on referme
      bag.on(item, 'focusout', function () {
        later(function () {
          if (megaItem === item && !item.contains(doc.activeElement) && !matches(item, ':hover')) megaClose();
        }, 0);
      });
    });
    bag.on(veil, 'click', function () { megaClose(); });
    bag.on(doc, 'keydown', function (e) {
      if (!isEsc(e) || !megaItem || MP.layer.isOpen()) return;
      megaClose({ focus: megaItem.contains(doc.activeElement) });
    });
    bag.on(doc, 'mp:layer:open', function () { megaClose(); });
    bag.undo.push(onMq(MP.mq && MP.mq.desktop, function () {
      if (!isDesktop()) megaClose();
      else if (drawer && MP.layer.isOpen(drawer)) MP.layer.close({ silent: true });
      measure();
    }));

    /* ===== 4. Tiroir mobile en tiroirs successifs ===== */
    var drawerApi = (function () {
      if (!drawer) return null;
      var levels = $$('[data-mp-level]', drawer);
      var rootLevel = $('[data-mp-level="root"]', drawer);
      var openerRow = null;

      function setActive(level) {
        levels.forEach(function (l) { l.classList.toggle('is-active', l === level); });
        $$('[data-mp-level-open]', drawer).forEach(function (b) {
          b.setAttribute('aria-expanded', level !== rootLevel && b.getAttribute('data-mp-level-open') === level.id ? 'true' : 'false');
        });
      }
      function showLevel(level, opener) {
        level.scrollTop = 0;
        openerRow = opener || null;
        setActive(level);
        later(function () { focusEl($('[data-mp-level-back]', level) || level); }, 80);
      }
      function showRoot(focus) {
        if (!rootLevel) return;
        setActive(rootLevel);
        if (focus && openerRow) {
          var back = openerRow;
          later(function () { focusEl(back); }, 80);
        }
        openerRow = null;
      }
      // retour au niveau 1 sans animation (tiroir ferme ou rouvert)
      function resetInstant() {
        drawer.classList.add('is-instant');
        showRoot(false);
        if (rootLevel) rootLevel.scrollTop = 0;
        raf(function () { raf(function () { drawer.classList.remove('is-instant'); }); });
      }
      function open(opener) {
        megaClose();
        resetInstant();
        MP.layer.open(drawer, opener);
      }

      bag.on(drawer, 'click', function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        var o = t.closest('[data-mp-level-open]');
        if (o) {
          var lv = doc.getElementById(o.getAttribute('data-mp-level-open'));
          if (lv) { e.preventDefault(); showLevel(lv, o); }
          return;
        }
        if (t.closest('[data-mp-level-back]')) {
          e.preventDefault();
          showRoot(true);
        }
      });
      // Echap au niveau 2 : retour au niveau 1 (MP.layer ignore une touche deja traitee)
      bag.on(drawer, 'keydown', function (e) {
        if (!isEsc(e) || !rootLevel || rootLevel.classList.contains('is-active')) return;
        e.preventDefault();
        showRoot(true);
      });
      bag.on(drawer, 'mp:layer:close', function (e) {
        if (e.target !== drawer) return;
        later(function () { if (!MP.layer.isOpen(drawer)) resetInstant(); }, 400);
      });
      $$('[data-mp-menu-open]', root).forEach(function (b) {
        bag.on(b, 'click', function (e) {
          e.preventDefault();
          if (MP.layer.isOpen(drawer)) MP.layer.close();
          else open(b);
        });
      });

      // glisser vers la gauche pour fermer
      var sx = 0;
      var sy = 0;
      var dx = 0;
      var mode = null;
      bag.on(drawer, 'touchstart', function (e) {
        mode = null;
        dx = 0;
        if (e.touches.length !== 1) return;
        if (e.target.closest && e.target.closest('[data-mp-noswipe]')) { mode = 'v'; return; }
        sx = e.touches[0].clientX;
        sy = e.touches[0].clientY;
      }, { passive: true });
      bag.on(drawer, 'touchmove', function (e) {
        if (mode === 'v' || e.touches.length !== 1) return;
        var x = e.touches[0].clientX - sx;
        var y = e.touches[0].clientY - sy;
        if (!mode) {
          if (Math.abs(x) < 10 && Math.abs(y) < 10) return;
          mode = x < 0 && Math.abs(x) > Math.abs(y) * 1.2 ? 'h' : 'v';
          if (mode === 'h') drawer.classList.add('is-dragging');
        }
        if (mode === 'h') {
          dx = Math.min(0, x);
          drawer.style.transform = 'translateX(' + dx + 'px)';
        }
      }, { passive: true });
      function endDrag() {
        if (mode === 'h') {
          drawer.classList.remove('is-dragging');
          drawer.style.transform = '';
          if (dx < -Math.min(100, drawer.offsetWidth * 0.25)) MP.layer.close();
        }
        mode = null;
        dx = 0;
      }
      bag.on(drawer, 'touchend', endDrag);
      bag.on(drawer, 'touchcancel', endDrag);

      return { open: open, showLevel: showLevel, showRoot: showRoot };
    })();

    /* ===== 5. Recherche predictive ===== */
    var searchApi = (function () {
      if (!search) return null;
      var input = $('[data-mp-search-input]', search);
      var idle = $('[data-mp-search-idle]', search);
      var box = $('[data-mp-search-results]', search);
      var status = $('[data-mp-search-status]', search);
      var clearBtn = $('[data-mp-search-clear]', search);
      var form = $('form', search);
      var body = $('[data-mp-search-body]', search);
      var tplBrands = $('template[data-mp-search-brands]', search);
      var routes = (MP.config && MP.config.routes) || {};
      var searchUrl = routes.search || '/search';
      var endpoint = (routes.predictive || '/search/suggest') + '.json';
      var cache = {};
      var timer = null;
      var ctrl = null;
      var seq = 0;
      var lastQ = '';
      if (!input || !box) return null;

      function say(text) { if (status) { status.textContent = ''; later(function () { status.textContent = text; }, 60); } }
      function allUrl(q) { return searchUrl + '?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last'; }
      function abort() {
        if (ctrl) { try { ctrl.abort(); } catch (e) {} }
        ctrl = null;
      }
      function showIdle() {
        abort();
        lastQ = '';
        search.classList.remove('is-loading');
        box.hidden = true;
        box.innerHTML = '';
        if (idle) idle.hidden = false;
      }
      // prix du Predictive Search : chaine decimale ("88.00") ; nombre entier = centimes
      function cents(v) {
        if (v == null || v === '') return 0;
        if (typeof v === 'number') return Math.round(v);
        var n = parseFloat(String(v).replace(',', '.'));
        return isNaN(n) ? 0 : Math.round(n * 100);
      }
      function sized(url, w) {
        if (!url) return '';
        return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
      }
      // meme rendu que snippets/mp-card.liquid avec class: 'mp-card--mini' (classes de mp-base.css)
      function card(p) {
        var img = (p.featured_image && p.featured_image.url) || p.image || '';
        var name = cleanTitle(p.title);
        var alt = (p.featured_image && p.featured_image.alt) || name || '';
        var now = cents(p.price);
        var was = cents(p.compare_at_price_max);
        var min = cents(p.price_min);
        var max = cents(p.price_max);
        var price;
        if (was > now) {
          price = '<span class="mp-vh">' + esc(G('sale_price', 'Sale price')) + ' </span><span class="mp-price__now mp-price__now--sale">' + esc(MP.money(now)) + '</span>' +
            '<span class="mp-vh"> ' + esc(G('regular_price', 'Regular price')) + ' </span><s class="mp-price__was">' + esc(MP.money(was)) + '</s>';
        } else if (max > min && min > 0) {
          price = '<span class="mp-price__now"><span class="mp-price__from">' + esc(G('price_from', 'From')) + '\u00a0</span>' + esc(MP.money(min)) + '</span>';
        } else {
          price = '<span class="mp-price__now">' + esc(MP.money(now)) + '</span>';
        }
        var cls = 'mp-card mp-card--mini' + (String(p.type || p.product_type || '').indexOf('Shoes') > -1 ? ' mp-card--contain' : '');
        var media = img
          ? '<img class="mp-card__img mp-card__img--main" src="' + esc(sized(img, 360)) + '" srcset="' +
            esc(sized(img, 240)) + ' 240w, ' + esc(sized(img, 360)) + ' 360w, ' + esc(sized(img, 540)) + ' 540w" ' +
            'sizes="(min-width: 1200px) 12vw, (min-width: 750px) 22vw, 30vw" width="360" height="480" loading="lazy" alt="' + esc(alt) + '">'
          : '';
        return '<li><article class="' + cls + '" data-product-id="' + esc(p.id) + '">' +
          '<div class="mp-card__media">' + media + '</div>' +
          '<div class="mp-card__body">' +
          '<p class="mp-card__title"><a class="mp-card__link" href="' + esc(p.url) + '">' + esc(name) + '</a></p>' +
          '<p class="mp-card__price mp-price">' + price + '</p>' +
          '</div></article></li>';
      }
      // seul <mark> est garde du texte stylise renvoye par Shopify
      function styled(q) {
        return esc(q.styled_text || q.text).replace(/&lt;(\/?)mark&gt;/g, '<$1mark>');
      }
      function emptyHtml(q) {
        var brands = tplBrands ? tplBrands.innerHTML.trim() : '';
        return '<div class="mp-header__empty">' +
          '<p class="mp-header__empty-title">' + esc(T('no_results_title', 'No results for \u201c[q]\u201d.', { q: q })) + '</p>' +
          '<p class="mp-header__empty-text">' + esc(T('no_results_text', 'Try another word or browse our categories.')) + '</p>' +
          (brands ? '<div class="mp-header__chips">' + brands + '</div>' : '') +
          '</div>';
      }
      function render(q, res) {
        search.classList.remove('is-loading');
        var products = res.products || [];
        var queries = (res.queries || []).filter(function (x) { return x && x.text; });
        var cols = (res.collections || []).filter(function (c) {
          return c && EXCLUDED_COLLECTIONS.indexOf(c.handle) === -1;
        });
        box.hidden = false;
        if (!products.length && !queries.length && !cols.length) {
          // jamais d'impasse : message, rubriques du menu, puis recherches populaires et nouveautes
          box.innerHTML = emptyHtml(q);
          if (idle) idle.hidden = false;
          say(T('no_results_status', 'No results for [q].', { q: q }));
          return;
        }
        if (idle) idle.hidden = true;
        var h = '<div class="mp-header__res">';
        if (queries.length) {
          h += '<div class="mp-header__res-q"><p class="mp-header__res-title" id="mp-res-q">' + esc(T('suggestions', 'Suggestions')) + '</p>' +
            '<ul class="mp-header__res-list" role="list" aria-labelledby="mp-res-q">' +
            queries.map(function (x) {
              return '<li><a href="' + esc(x.url || allUrl(x.text)) + '">' + styled(x) + '</a></li>';
            }).join('') + '</ul></div>';
        }
        if (products.length) {
          h += '<div class="mp-header__res-p"><p class="mp-header__res-title" id="mp-res-p">' + esc(T('products', 'Products')) + '</p>' +
            '<ul class="mp-header__res-grid" role="list" aria-labelledby="mp-res-p">' + products.map(card).join('') + '</ul></div>';
        }
        if (cols.length) {
          h += '<div class="mp-header__res-c"><p class="mp-header__res-title" id="mp-res-c">' + esc(T('collections', 'Collections')) + '</p>' +
            '<ul class="mp-header__res-list" role="list" aria-labelledby="mp-res-c">' +
            cols.map(function (c) { return '<li><a href="' + esc(c.url) + '">' + esc(sentence(c.title)) + '</a></li>'; }).join('') +
            '</ul></div>';
        }
        h += '<div class="mp-header__res-all"><a class="mp-btn mp-btn--outline mp-btn--s" href="' + esc(allUrl(q)) + '">' + esc(T('view_all_results', 'View all results')) + '</a></div>';
        h += '</div>';
        box.innerHTML = h;
        var n = products.length;
        say(n ? (n > 1 ? T('suggested_many', '[count] products suggested.', { count: n }) : T('suggested_one', '1 product suggested.')) : T('suggestions_available', 'Suggestions available.'));
      }
      function renderError(q) {
        search.classList.remove('is-loading');
        box.hidden = false;
        box.innerHTML = '<div class="mp-header__empty"><p class="mp-header__empty-text">' +
          esc(T('search_unavailable', 'Quick search is unavailable. Press Enter to see results for \u201c[q]\u201d.', { q: q })) + '</p></div>';
        if (idle) idle.hidden = false;
      }
      function run(q) {
        if (q === lastQ) return;
        lastQ = q;
        if (cache[q]) { render(q, cache[q]); return; }
        abort();
        var my = ++seq;
        ctrl = window.AbortController ? new AbortController() : null;
        search.classList.add('is-loading');
        var p = new URLSearchParams();
        p.set('q', q);
        p.set('resources[type]', 'product,collection,query');
        p.set('resources[limit]', '6');
        p.set('resources[limit_scope]', 'each');
        p.set('resources[options][unavailable_products]', 'last');
        fetch(endpoint + '?' + p.toString(), {
          credentials: 'same-origin',
          headers: { Accept: 'application/json' },
          signal: ctrl ? ctrl.signal : undefined
        })
          .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.json(); })
          .then(function (j) {
            var res = (j && j.resources && j.resources.results) || {};
            cache[q] = res;
            if (my === seq) render(q, res);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
            if (my === seq) { lastQ = ''; renderError(q); }
          });
      }

      bag.on(input, 'input', function () {
        var q = input.value.trim();
        if (clearBtn) clearBtn.hidden = !input.value;
        clearTimeout(timer);
        if (q.length < 2) { showIdle(); return; }
        timer = setTimeout(function () { run(q); }, 220);
      });
      bag.on(clearBtn, 'click', function (e) {
        e.preventDefault();
        input.value = '';
        clearBtn.hidden = true;
        showIdle();
        focusEl(input);
      });
      bag.on(form, 'submit', function (e) {
        if (!input.value.trim()) { e.preventDefault(); focusEl(input); }
      });
      // fleche bas depuis le champ, puis haut et bas entre les liens visibles
      bag.on(search, 'keydown', function (e) {
        var k = e.key;
        if (k !== 'ArrowDown' && k !== 'ArrowUp' && k !== 'Down' && k !== 'Up') return;
        var links = $$('a[href]', body).filter(visible);
        if (!links.length) return;
        var down = k === 'ArrowDown' || k === 'Down';
        if (doc.activeElement === input) {
          if (down) { e.preventDefault(); focusEl(links[0]); }
          return;
        }
        var at = links.indexOf(doc.activeElement);
        if (at < 0) return;
        e.preventDefault();
        if (down) focusEl(links[Math.min(links.length - 1, at + 1)]);
        else if (at === 0) focusEl(input);
        else focusEl(links[at - 1]);
      });
      bag.on(search, 'mp:layer:close', function (e) {
        if (e.target !== search) return;
        clearTimeout(timer);
        abort();
      });
      function open(opener) {
        megaClose();
        if (MP.layer.isOpen(search)) { focusEl(input); return; }
        MP.layer.open(search, opener || doc.activeElement);
        // focus synchrone : sur iOS le clavier ne s'ouvre que dans le geste de la personne
        focusEl(input);
        var q = input.value.trim();
        if (q.length >= 2) {
          try { input.select(); } catch (e) {}
          run(q);
        }
      }
      return { open: open, close: function () { if (MP.layer.isOpen(search)) MP.layer.close(); } };
    })();

    /* ===== 6. Editeur de theme : blocs selectionnes ===== */
    function onBlockSelect(el) {
      if (!el) return;
      if (announce && el.hasAttribute('data-mp-msg')) { announce.select(el); return; }
      var item = el.closest ? el.closest('[data-mp-mega-item]') : null;
      if (item && isDesktop()) { megaOpen(item); return; }
      if (searchApi && search.contains(el)) searchApi.open();
    }
    function onBlockDeselect() {
      if (announce) announce.resume();
      megaClose();
    }

    function destroy() {
      bag.off();
      timers.forEach(clearTimeout);
      clearTimeout(openT);
      clearTimeout(closeT);
      [drawer, search].forEach(function (p) {
        if (!p) return;
        if (MP.layer.isOpen(p)) MP.layer.close({ silent: true });
        if (p.parentNode) p.parentNode.removeChild(p);
      });
      host.classList.remove('is-mp-hidden');
    }

    return {
      root: root,
      openSearch: function (opener) { if (searchApi) searchApi.open(opener); },
      closeSearch: function () { if (searchApi) searchApi.close(); },
      openMenu: function (opener) { if (drawerApi) drawerApi.open(opener); },
      // ouvre le panneau d'une rubrique par son titre (editeur, maquette, autres surfaces)
      openMega: function (title) {
        var want = String(title || '').trim().toLowerCase();
        var item = items.filter(function (it) {
          var l = linkOf(it);
          return l && l.textContent.trim().toLowerCase() === want;
        })[0];
        if (item) megaOpen(item);
      },
      closeMega: function () { megaClose(); },
      show: function () { setHidden(false); anchor = scrollTop(); },
      isHidden: function () { return hidden; },
      measure: measure,
      onBlockSelect: onBlockSelect,
      onBlockDeselect: onBlockDeselect,
      destroy: destroy,
      hasSearch: !!searchApi
    };
  }

  function boot(root) {
    if (current) { current.destroy(); current = null; }
    if (root) current = create(root);
  }

  /* ---------- Ecouteurs globaux (une seule fois) ---------- */
  // tout element [data-mp-search-open] de la page ouvre le panneau (clic molette / ctrl : lien normal)
  doc.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-mp-search-open]') : null;
    if (!t || !current || !current.hasSearch) return;
    if (e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    current.openSearch(t);
  });
  // libelle accessible du lien panier (le compteur visible est mis a jour par mp-cart.js)
  doc.addEventListener('mp:cart:updated', function (e) {
    var n = e.detail ? Number(e.detail.item_count) : NaN;
    if (isNaN(n)) return;
    $$('[data-mp-cart-label]').forEach(function (a) { a.setAttribute('aria-label', cartLabel(n)); });
  });
  doc.addEventListener('shopify:section:load', function (e) {
    var r = e.target && e.target.querySelector ? e.target.querySelector('[data-mp-header]') : null;
    if (r) boot(r);
  });
  doc.addEventListener('shopify:section:unload', function (e) {
    if (current && e.target && e.target.contains && e.target.contains(current.root)) {
      current.destroy();
      current = null;
    }
  });
  doc.addEventListener('shopify:block:select', function (e) {
    if (current) current.onBlockSelect(e.target);
  });
  doc.addEventListener('shopify:block:deselect', function () {
    if (current) current.onBlockDeselect();
  });

  MP.header = {
    __v5: true,
    openSearch: function (opener) { if (current) current.openSearch(opener); },
    closeSearch: function () { if (current) current.closeSearch(); },
    openMenu: function (opener) { if (current) current.openMenu(opener); },
    openMega: function (title) { if (current) current.openMega(title); },
    closeMega: function () { if (current) current.closeMega(); },
    show: function () { if (current) current.show(); },
    isHidden: function () { return current ? current.isHidden() : false; },
    measure: function () { if (current) current.measure(); }
  };

  MP.ready(function () { boot($('[data-mp-header]')); });
})();
